export const genericLabelProps = {
    style: {
        fontSize: "1.2rem",
        paddingBottom: "0.5rem",
    },
    shrink: true,
};